export default "__VITE_ASSET__zio0Ws3c__"